import { render } from "./AdminIndex.vue?vue&type=template&id=baa6274e&scoped=true"
import script from "./AdminIndex.vue?vue&type=script&lang=js"
export * from "./AdminIndex.vue?vue&type=script&lang=js"

import "./AdminIndex.vue?vue&type=style&index=0&id=baa6274e&scoped=true&lang=css"

import exportComponent from "D:\\NVManh\\Github\\MS.eShop\\eShopV2\\web-thaisalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baa6274e"]])

export default __exports__